module.exports = __webpack_public_path__ + "media/images/sandbox/megaman--thumb-16dff1c01a696c24c329086a616c5bf0.png";